import router from '@/router'
import { useStorage } from '@vueuse/core'
import { createStore } from 'vuex'
import api from '@/api'
import { buildTimeInfo } from '@/utils/rocDate'

const userStorage = useStorage('B&WBCUser', {
  registeredEmail: '',
  validDate: new Date().setHours(23, 59, 59, 59),
})

export default createStore({
  state: {
    sidebarVisible: '',
    // sidebarUnfoldable: false,
    registeredEmail: userStorage.value.registeredEmail,
    applyDepartment: 'buddhism_application',
    registrationForm: {},
    // 時間資訊（由 /academicSetting/current 載入）
    timeInfo: buildTimeInfo(null),
    // 目前公告梯次原始資料（繳費截止時間等計算用）
    currentSetting: null,
    // 聯絡資訊
    officialInfo: {
      name: '福智佛教學院招生委員會',
      tel: '(05)5828225 分機1201、1202',
      email: 'enroll@bwbc.edu.tw',
    },
    bank: {
      code: '007',
      account: '21310039991',
    },
  },
  mutations: {
    toggleSidebar(state) {
      state.sidebarVisible = !state.sidebarVisible
    },
    // toggleUnfoldable(state) {
    //   state.sidebarUnfoldable = !state.sidebarUnfoldable
    // },
    updateSidebarVisible(state, payload) {
      state.sidebarVisible = payload.value
    },
    updateRegisteredEmail(state, payload) {
      state.registeredEmail = payload.value
      userStorage.value.registeredEmail = payload.value
      userStorage.value.validDate = new Date().setHours(23, 59, 59, 59)
    },
    updateApplyDepartment(state, payload) {
      state.applyDepartment = payload.value
    },
    updateRegistrationForm(state, payload) {
      state.registrationForm = payload.value
    },
    updateCurrentSetting(state, payload) {
      state.currentSetting = payload.value
      state.timeInfo = buildTimeInfo(payload.value)
    },
  },
  actions: {
    async loadTimeInfo({ commit }) {
      try {
        const res = await api.AcademicSetting.getCurrent()
        commit('updateCurrentSetting', { value: res.data || null })
      } catch (error) {
        // 取得失敗時維持空白
      }
    },
    checkLoginValid({ commit }) {
      if (!userStorage.value.registeredEmail) {
        return false
      }
      if (new Date() > new Date(userStorage.value.validDate)) {
        commit('updateRegisteredEmail', {
          value: null,
        })
        return false
      }
      return true
    },
    logout({ commit }) {
      router.push('/pages/login')
      commit('updateRegisteredEmail', {
        value: null,
      })
    },
  },
  modules: {},
})
